<template>
  <i-modal
    :title="$t('create_customer')"
    :value="value"
    :load="loading"
    @submit="submit()"
    @close="close()"
  >
    <v-row>
      <v-col cols="12" md="6">
        <ValidationProvider
          vid="first_name"
          :name="$t('name')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="form.first_name"
            :label="$t('name')"
            :error-messages="errors[0]"
            outlined
            dense
          />
        </ValidationProvider>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="form.last_name"
          :label="$t('last_name')"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="form.company_name"
          :label="$tc('company', 1)"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="form.email"
          :label="$tc('email', 1)"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" md="6">
        <!-- El teléfono no se edita: es el número desde el que escribió -->
        <v-text-field
          :value="conversation ? conversation.contact_phone : ''"
          :label="$tc('phone', 1)"
          outlined
          dense
          disabled
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          v-model="form.level"
          :items="levels"
          item-text="name"
          item-value="pk"
          :label="$tc('level', 1)"
          outlined
          dense
          clearable
        />
      </v-col>
    </v-row>
  </i-modal>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'customer-dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    conversation: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      loading: false,
      levels: [],
      form: {
        first_name: '',
        last_name: '',
        company_name: '',
        email: '',
        level: null
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData'
    })
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    reset() {
      // El nombre de perfil de WhatsApp suele traer nombre y apellido juntos
      const profile = (
        this.conversation ? this.conversation.profile_name || '' : ''
      ).trim()
      const parts = profile.split(' ')

      this.form = {
        first_name: parts.length > 0 ? parts[0] : '',
        last_name: parts.length > 1 ? parts.slice(1).join(' ') : '',
        company_name: '',
        email: '',
        level: null
      }
    },
    async submit() {
      if (!this.conversation) {
        return
      }
      this.loading = true
      try {
        const response = await this.$api.whatsapp.createCustomer({
          pk: this.conversation.pk,
          form: this.form,
          opt: { params: { company_id: this.company.pk } }
        })
        this.$toast.success(
          `${this.$tc('customer', 1)} ${this.$tc('created', 1)}`
        )
        this.$emit('created', response.data)
        this.close()
      } finally {
        this.loading = false
      }
    },
    async loadLevels() {
      const response = await this.$api.customer.level.list({
        opt: { params: { company_id: this.company.pk } }
      })
      this.levels =
        response.data.results !== undefined
          ? response.data.results
          : response.data
    }
  },
  watch: {
    value(opened) {
      if (opened) {
        this.reset()
      }
    }
  },
  mounted() {
    this.loadLevels()
  }
}
</script>
